<template>
    <div>
        <tab name="2"></tab>
        <div v-loading="listLoading">
            <div class="page-filter-box">
                <el-radio-group v-model="type" size="small" @change="reset">
                    <el-radio-button :label="0">秀动订单多出</el-radio-button>
                    <el-radio-button :label="1">支付平台多出</el-radio-button>
                    <el-radio-button :label="2">金额不一致</el-radio-button>
                </el-radio-group>
                <el-row class="MT10" :gutter="20">
                    <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                        <el-input v-model="params.searchValue" class="input-with-select" size="small">
                            <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                                <el-option label="订单编号" :value="1"></el-option>
                                <el-option v-if="type != 1" label="订单ID" :value="2"></el-option>
                            </el-select>
                        </el-input>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                        <div class="clearfix timeType">
                            <el-input class="input-with-select fl" size="small">
                                <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                    <!-- <el-option label="下单时间" :value="1"></el-option> -->
                                    <el-option label="支付时间" :value="2"></el-option>
                                </el-select>
                            </el-input>
                            <el-date-picker v-model="datetimerange" type="daterange" start-placeholder="开始日期"
                                end-placeholder="结束日期" class="fl" size="small" value-format="yyyyMMdd" align="right"
                                unlink-panels :clearable="false">
                            </el-date-picker>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                        <el-select v-model="params.reconciliationStatus" placeholder="请选择对账状态" size="small">
                            <el-option label="不限对账状态" value=""></el-option>
                            <el-option label="对账失败" :value="0"></el-option>
                            <el-option label="业务对账成功" :value="1"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="page-btns-box">
                <el-button v-if="$utils.have('/finance/batchAbnormalDataList')" type="primary" size="small"
                    @click="batch()">批量通过</el-button>
                <el-button v-if="$utils.have('/finance/abnormalDataListExport')" type="primary" size="small"
                    @click="download" :loading="downLoading">导出列表</el-button>
            </div>
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" size="small" stripe >
                    <el-table-column label="选择" width="50">
                        <template slot="header" slot-scope="scope">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">&nbsp;</el-checkbox>
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox-group v-model="ids" @change="selectData">
                                <el-checkbox :disabled="scope.row.reconciliationStatus !== '对账失败'" :label="scope.row.orderSn" size="mini">&nbsp;</el-checkbox>
                            </el-checkbox-group>
                        </template>
                    </el-table-column>                   
					<el-table-column label="业务" prop="orderType" v-if="type != 1">
						<template slot-scope="scope">{{ orderType[scope.row.orderType] }}</template>
					</el-table-column>
					<el-table-column label="订单编号" prop="orderSn" min-width="160">
						<template slot-scope="scope">                              
							<el-link v-if="scope.row.orderType == 1" type="primary" :href="`/activityManage/order/edit/${scope.row.orderId}`">{{scope.row.orderSn}}</el-link>
							<el-link v-else-if="scope.row.orderType == 2" type="primary" :href="`/raise/order/edit/${scope.row.orderId}`">{{scope.row.orderSn}}</el-link>
							<el-link v-else-if="scope.row.orderType == 3" type="primary" :href="`/goodsManage/order/edit/${scope.row.orderId}`">{{scope.row.orderSn}}</el-link>
							<span v-else>{{scope.row.orderSn}}</span>                                
						</template>
					</el-table-column>
                    <el-table-column label="支付渠道" prop="payPlatform" min-width="100"></el-table-column>
                    
                    <el-table-column v-if="params.type == 1" label="商户订单号" prop="orderSn" min-width="140"></el-table-column>
                    
                    <el-table-column label="支付平台交易号" prop="outTradeNo" min-width="230"></el-table-column>
                    
                    
                    <template v-if="params.type == 2">
                        <el-table-column label="秀动支付金额" prop="payPrice" min-width="100"></el-table-column>
                        <el-table-column label="支付平台支付金额" prop="platformPayPrice" min-width="120"></el-table-column>
                    </template>
                    <el-table-column v-else :label="params.type == 1 ? '支付金额' : '实际支付'" prop="payPrice"></el-table-column>

                    <template v-if="params.type == 0">
                        <el-table-column label="支付状态" prop="payStatus"></el-table-column>
                        <el-table-column label="订单状态" prop="orderStatus"></el-table-column>
                        <el-table-column label="下单时间" prop="createTime" min-width="150"></el-table-column>
                        <el-table-column label="下单终端" prop="terminal"></el-table-column>
                    </template>

                    <el-table-column label="支付成功时间" prop="successTime" min-width="150"></el-table-column>
                    <el-table-column label="对账状态" prop="reconciliationStatus" min-width="100"></el-table-column>
                    <el-table-column label="对账备注" prop="reconciliationNotes" show-overflow-tooltip></el-table-column>
                    <el-table-column label="对账处理人" prop="reconciliationUser" show-overflow-tooltip min-width="90">
                    </el-table-column>
                    <el-table-column label="对账处理时间" prop="reconciliationTime" min-width="150"></el-table-column>
                </el-table>
            </div>
            <div v-if="data" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </div>

        <batch ref="batch" @onUpdate="getDataList"></batch>
    </div>
</template>

<script>
import Tab from '../components/tab.vue';
import { downloadFileTmp } from '@/assets/js/commonApi.js';
import Batch from '../components/batch.vue';
const defaultParams = {
    "pageNo": 1,
    "reconciliationStatus": 0,
    "searchType": 1,
    "searchValue": "",
    "type": 0,
    "timeType": 2,
}
export default {
    components: { Tab, Batch},
    data() {
        const endTime = this.$utils.formatDate((new Date().getTime()), 'yyyyMMdd');
        const startTime = '20220801';//this.$utils.formatDate((new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyyMMdd');
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                reconciliationStatus: parseInt(this.$route.query.reconciliationStatus || 0),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                type: parseInt(this.$route.query.type || 0),
                timeType: parseInt(this.$route.query.timeType || 2),
            },
            listLoading: true,
            datetimerange: [],
            defaultDatetimerange: [this.$route.query.startTime || startTime, this.$route.query.endTime || endTime],
            downLoading: false,
            type: parseInt(this.$route.query.type || 0),
            orderType: {
                1: '演出',
                2: '众筹',
                3: '周边',
				7: '演出会员',
            },
            ids: [],
            isIndeterminate: false,
            checkAll: false,
        }
    },
    mounted() {
        this.datetimerange = this.defaultDatetimerange;
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || '',
                type: this.type
            }
            const _url = {
                0: '/finance/abnormalDataList/showList',
                1: '/finance/abnormalDataList/platformList',
                2: '/finance/abnormalDataList/amountList'
            }
            this.$request({
                url: _url[this.params.type],
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result || null;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.data = null;
                    this.dataList = [];
                    this.$message.error("请求错误");
                })
                .finally(() => {

                    this.checkAll = false;
                    this.isIndeterminate = false;
                    this.ids = [];
                    
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = this.defaultDatetimerange;
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出
        async download() {
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url: "/finance/abnormalDataListExport",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .catch(err => {
                    this.$message({ message: err.message, type: 'error' });
                })
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            } else {
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }
            const _fname = {
                0: '秀动订单多出',
                1: '支付平台多出',
                2: '金额不一致'
            }
            await downloadFileTmp(filePath, `异常收款对账单-${_fname[this.type]}.` + this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //全选、反选
        handleCheckAllChange(val) {
            this.ids = val ? (this.dataList.filter(v => v.reconciliationStatus === '对账失败')).map( v => v.orderSn ) : [];
            this.isIndeterminate = false;
        },
        //选择
        selectData(value){
            
            let checkedCount = value.length;
            const _dataList = this.dataList.filter(v => v.reconciliationStatus === '对账失败');
            this.checkAll = checkedCount === _dataList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < _dataList.length;
        },
        //批量
        batch(){
            if( this.ids.length < 1 ){
                return this.$message.warning('请选择需要处理的订单');
            }else{
                this.$refs.batch.show(this.ids,this.params.type);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>